<ng-container *ngIf="!!get">
    <tt-card>
        <tt-tabs [(ttSelectedId)]="get.bg_projects_activestatus" (ttSelectedIdChange)="loadProjects()">
            <tt-tab ttId="ACTIVE" ttLabel="bg_projects_activestatus_active"></tt-tab>
            <tt-tab ttId="NOTACTIVE" ttLabel="bg_projects_activestatus_notactive"></tt-tab>
        </tt-tabs>
        <tt-input ttLabel="projects_searchtext" [(ttModel)]="get.searchtext" ttShowClearButton></tt-input>
    </tt-card>
    <tt-list ttHeightFull [ttData]="projects" [ttFilter]="get.searchtext" ttBackStyle [ttGoto]="false" (ttClick)="onProjectSelected($event)"></tt-list>
    <tt-card *ngIf="get.show_setting === '1'">
        <tt-button-settings></tt-button-settings>
    </tt-card>
</ng-container>
